import { useChat } from "@/providers/chat-provider";
import { Loader2Icon } from "lucide-react";
import Image from "next/image";
import ChatItem from "../chat-item";
import PinnedChats from "../pinned-chats";

const DirectChatsTab = () => {
	const { inbox, pinnedChatUniqueIds } = useChat();

	const { isLoading = false, isError = false, chats = [] } = inbox;

	const directChats = chats.filter(
		(chat) => chat.type === "direct" && !pinnedChatUniqueIds.includes(chat.uniqueChatId)
	);

	return (
		<div className="customized-scrollbar max-h-[calc(100vh-10.5rem)] overflow-y-scroll p-2">
			<div className="space-y-3">
				<PinnedChats showGroupChats={false} />

				{isLoading ? (
					<Loader2Icon className="mx-auto h-8 w-8 animate-spin stroke-brand-primary" />
				) : isError ? (
					<span>Error</span>
				) : directChats && directChats.length > 0 ? (
					directChats?.map((chat) => (
						<ChatItem
							logo={chat?.logo}
							key={chat.uniqueChatId}
							timestamp={chat?.timestamp}
							lastMessage={chat?.lastMessage}
							isSuggestion={chat?.suggestion}
							uniqueChatId={chat?.uniqueChatId}
							name={chat?.recipient?.name || "User"}
							onlineUsersCount={chat?.onlineUsersCount}
							recipient={chat?.recipient}
						/>
					))
				) : (
					<div className="py-6 text-center">
						<Image
							src="/images/chat/empty-inbox.svg"
							alt="No chats found"
							width={652}
							height={737}
							className="mx-auto w-40 object-contain grayscale"
						/>
						<p className="mt-3 text-sm text-gray-600">No chats found</p>
					</div>
				)}
			</div>
		</div>
	);
};

export default DirectChatsTab;
